var exports = {
  "_J": "shimmerAnimation__1rfv6n",
  "Pm": "TextPlaceHolder__6AV58I",
  "Nf": "PillPlaceholder__i13Nzh",
  "VM": "AvatarPlaceholder__JEQ5qn",
};

module.exports = exports;
